import { Button, Modal } from 'react-bootstrap';

const ConfirmationModal = ({show, setShow, onConfirm, message="", variant="warning"}) => {

    return (
        <Modal size="sm" show={show} centered onHide={() => setShow(false)} >
            <Modal.Body className="d-flex flex-column gap-4 bg-dark p-4 rounded">
                <span>{message}</span>
                <div className="d-flex justify-content-between">
                    <Button className="border-secondary" variant="dark" onClick={() => setShow(false)}>
                        Cancel
                    </Button>
                    <Button variant={variant} type="button" onClick={onConfirm}>
                        Confirm
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationModal;